// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.application-frame {
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  position: relative;
}
.application-frame .login-frame {
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: right;
}
.application-frame .login-frame input {
  width: 100%;
  margin-bottom: 2rem;
  box-sizing: border-box;
}
.application-frame .login-frame a {
  margin-bottom: 4rem;
  display: block;
  font-size: 1.4rem;
}
.application-frame .login-frame .button {
  width: 100%;
  box-sizing: border-box;
}
.application-frame .login-frame form h2 {
  text-align: center;
}
.application-frame .login-frame form h4 {
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./views/login/index.less"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,WAAA;EAAY,YAAA;EACZ,sBAAA;EACA,kBAAA;AAEJ;AACA;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AACJ;AAEA;EACI,WAAA;EACA,mBAAA;EACA,sBAAA;AAAJ;AAGA;EACI,mBAAA;EACA,cAAA;EACA,iBAAA;AADJ;AAIA;EACI,WAAA;EACA,sBAAA;AAFJ;AAKA;EACI,kBAAA;AAHJ;AAMA;EACI,kBAAA;AAJJ","sourcesContent":[".application-frame {\n    display: flex;\n    width:100%; height:100%;\n    flex-direction: column;\n    position: relative;\n}\n\n.application-frame .login-frame {\n    flex-grow: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: right;\n}\n\n.application-frame .login-frame input {\n    width:100%;\n    margin-bottom: 2rem;\n    box-sizing: border-box;\n}\n\n.application-frame .login-frame a {\n    margin-bottom: 4rem;\n    display: block;\n    font-size: 1.4rem;\n}\n\n.application-frame .login-frame .button {\n    width:100%;\n    box-sizing: border-box;\n}\n\n.application-frame .login-frame form h2 {\n    text-align: center;\n}\n\n.application-frame .login-frame form h4 {\n    text-align: center;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
